import { render, staticRenderFns } from "./search_medical.vue?vue&type=template&id=a0800d2a"
import script from "./search_medical.vue?vue&type=script&lang=js"
export * from "./search_medical.vue?vue&type=script&lang=js"
import style0 from "./search_medical.vue?vue&type=style&index=0&id=a0800d2a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports